<template>
  <div>
    <b-card title="Information de base" v-if="form">
      <b-alert
        v-if="form.is_in_erp"
        variant="danger"
        show
      >Attention champs modifiables uniquement depuis l'ERP !</b-alert>
      <b-form>
        <b-form-group
          id="addReferenceGroup1"
          label="Designation"
          label-for="exampleInput1"
        >
          <b-form-input
            id="exampleInput1"
            type="text"
            v-model="form.designation"
            required
            :disabled="isReadOnly()"
            placeholder="Entrez la désignation"
            aria-describedby="exampleInput1Feedback"
          />
          <b-form-invalid-feedback id="exampleInput1Feedback">Evitez les caractères spéciaux</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="customTax" label="Code Douane" label-for="customTaxInput">
          <b-form-input
            id="customTaxInput"
            type="text"
            :disabled="isReadOnly()"
            v-model="form.customs"
            required
          />
        </b-form-group>
        <b-form-group label="Poids Unitaire" label-for="poids" style="width: 100%">
          <b-form-input
            id="poids"
            type="number"
            v-model="form.weight"
            :disabled="isReadOnly()"
            required
            step="0.001"
            placeholder="Entrez le poids (kg)"
          />
        </b-form-group>
        <br />
        <b-row>
          <b-form-group label="Emplacement:" label-for="exampleInput5" style="width: 100%">
            <b-form-select
              style="display:inline; width:25%;float: left;"
              :options="zone"
              required
              v-model="form.zone"
              :disabled="isReadOnly()"
            />
            <b-form-select
              style="display:inline; width:25%;float: left;"
              :options="pos_y"
              required
              v-model="form.pos_y"
              :disabled="isReadOnly()"
            />
            <b-form-input
              style="display:inline; width:25%;float: left;"
              type="number"
              v-model="form.pos_x"
              required
              :disabled="isReadOnly()"
              placeholder="Enter number of card:"
            />
            <b-form-select
              style="display:inline; width:25%;float: left;"
              :options="pos_z"
              required
              v-model="form.pos_z"
              :disabled="isReadOnly()"
            />

            <UpdateInfoFromErp style="margin: 10px 0 0 0" v-if="form.is_in_erp"/>
          </b-form-group>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import server from '../../api/server.vue'
import { Zones } from '../../core/services/zones.js'
import { Aisles } from '../../core/services/aisles.js'
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'

import UpdateInfoFromErp from './UpdateInfoFromErp'

export default {
  name: 'ReferenceForm',
  data() {
    return {
      zone: Zones,
      logistic_loop: ['loop_external', 'loop_usual_components'],
      pos_y: Aisles,
      pos_z: Aisles
    }
  },
  computed: {
    ...mapGetters({
      form: 'getFormKanban'
    })
  },
  methods: {
    isReadOnly() {
      return this.form.is_in_erp
    }
  },
  mounted: function() {},
  components: { UpdateInfoFromErp }
}
</script>


// WEBPACK FOOTER //
// src/components/kanban/ReferenceForm.vue